import Grid from '@mui/joy/Grid'
import Avatar from '@mui/joy/Avatar'
import React, { useState } from 'react'
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle'
import Typography from '@mui/joy/Typography'

type ImageStampProps = {
  index: number
  stampImageUrl: string | null
  textColor: string
  fontFamily: string
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function ImageStamp(props: ImageStampProps) {
  const [date] = useState(getDate())

  return (
    <>
      {props.stampImageUrl && props.index === 1 && (
        <>
          <Grid container justifyContent="center" alignItems="center">
            <Avatar
              sx={{
                cursor: 'pointer',
              }}
              variant="plain"
              onClick={() =>
                document.getElementById(`logo-upload-${props.index}`)?.click()
              }
            >
              <ChangeCircleIcon fontSize="large" />
            </Avatar>

            <input
              accept="image/*"
              style={{ display: 'none' }}
              id={`logo-upload-${props.index}`}
              type="file"
              onChange={props.handleFileChange}
            />
          </Grid>
        </>
      )}
      {props.index > 2 && (
        <>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Avatar
              size="lg"
              variant="outlined"
              src={
                props.stampImageUrl
                  ? `${props.stampImageUrl}?timestamp=${Date.now()}`
                  : undefined
              }
              sx={{
                border: `2px solid ${props.textColor}`,
              }}
            >
              {' '}
            </Avatar>

            <Typography
              level="body-sm"
              fontWeight="md"
              textColor={props.textColor}
              fontFamily={props.fontFamily}
              fontSize={16}
              sx={{
                pt: 0.5,
                zIndex: 1,
              }}
            >
              {date}
            </Typography>
          </Grid>
        </>
      )}
    </>
  )
}

const getDate = (() => {
  let currentMonth = Math.floor(Math.random() * (12 - 1) + 1)
  let currentDay = Math.floor(Math.random() * (30 - 1) + 1)

  return () => {
    const randomIncrement = Math.floor(Math.random() * 5) + 1
    currentDay += randomIncrement

    if (currentDay > 30) {
      currentDay -= 30
      currentMonth++
    }

    if (currentMonth > 12) {
      currentMonth = 1
    }

    return `${currentMonth}/${currentDay}`
  }
})()

export default ImageStamp
